// const _extends = Object.assign;
const ra = require('react-admin');
const _fetch = ra.fetchUtils;
const querystring = require('query-string');

// Helper functions
/* Date.prototype.addHours = function (h) {
  this.setHours(this.getHours() + h);
  return this;
}; */

const toType = function (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};

const convertFilters = function (filters) {
  const rest = {};

  Object.keys(filters).forEach(key => {
    var specificFilter = key.split('@');
    if (specificFilter.length === 2) {
      var newKey = specificFilter[0];
      if (filters[key] === 'null') {
        rest[key] = `is.null`;
      } else {
        if (specificFilter[1] === 'ilike') {
          rest[newKey] = `${specificFilter[1]}.*${filters[key]}*`;
        } else if (specificFilter[1] === 'cs') {
          rest[newKey] = `cs.%7B${filters[key]}%7D`;
        } else {
          rest[newKey] = `${specificFilter[1]}.${filters[key]}`;
        }
      }
    } else {
      if (key === 'id' || key.indexOf('_id') !== -1) {
        switch (toType(filters[key])) {
          case 'array':
            let hasNulls = filters[key].filter(e => e === null);
            if (hasNulls.length === 1 && filters[key].length === 1) {
              rest[key] = `is.null`;
            }
            if (hasNulls.length === 1 && filters[key].length > 1) {
              let nonNulls = filters[key].filter(e => e !== null);
              let ftr = nonNulls.map(e => `${key}.eq.${e}`).join(',') + `,${key}.is.null`;
              rest['or'] = `(${ftr})`;
            }
            if (hasNulls.length === 0) {
              rest[key] = `in.(${filters[key].toString()})`;
            }
            break;
          default:
            if (filters[key] === null) {
              rest[key] = `is.null`;
            } else {
              rest[key] = `eq.${filters[key]}`;
            }
            break;
        }
        return rest;
      } else {
        switch (toType(filters[key])) {
          case 'string':
            if (filters[key].toLowerCase() === null) {
              rest[key] = `is.null`;
            } else {
              // Only encode once to avoid double encoding (e.g., %2520)
              const value = filters[key].replace(/:/, '');
              rest[key] = `ilike.*${encodeURIComponent(value)}*`;
            }
            break;
          case 'boolean':
            rest[key] = `is.${filters[key]}`;
            break;
          case 'undefined':
            rest[key] = 'is.null';
            break;
          case 'number':
            rest[key] = `eq.${filters[key]}`;
            break;
          case 'array':
            let hasNulls = filters[key].filter(e => e === null);
            if (hasNulls.length === 1 && filters[key].length === 1) {
              rest[key] = `is.null`;
            }
            if (hasNulls.length === 1 && filters[key].length > 1) {
              let nonNulls = filters[key].filter(e => e !== null);
              let ftr = nonNulls.map(e => `${key}.eq.${e}`).join(',') + `,${key}.is.null`;
              rest['or'] = `(${ftr})`;
            }
            if (hasNulls.length === 0) {
              rest[key] = `in.(${filters[key].toString()})`;
            }
            break;
          default:
            // Ensure encoding for default string filters as well
            const value = filters[key].toString().replace(/:/, '');
            rest[key] = `ilike.*${encodeURIComponent(value)}*`;
            break;
        }
      }
    }
  });
  return rest;
};

const convertRESTRequestToHTTP = function (apiUrl, type, resource, params) {
  let url = '';
  const options = { headers: new Headers() };
  let _params$sort, field, order;

  switch (type) {
    case 'GET_LIST': {
      if (params.pagination) {
        const { page, perPage } = params.pagination;
        options.headers.set('Range-Unit', 'items');
        options.headers.set('Range', `${(page - 1) * perPage}-${page * perPage - 1}`);
        options.headers.set('Prefer', 'count=exact');
      }

      _params$sort = params.sort;
      field = _params$sort.field;
      order = _params$sort.order;
      const sel = params.select ? `&select=${params.select.join(',')}` : '';
      const query = { order: `${field}.${order.toLowerCase()}`, ...convertFilters(params.filter) };

      url = `${apiUrl}/${resource}?${querystring.stringify(query, { strict: false, encode: false })}${sel}`;
      break;
    }
    case 'GET_ONE':
      url = `${apiUrl}/${resource}?id=eq.${params.id}`;
      break;
    case 'GET_MANY':
      url = `${apiUrl}/${resource}?id=in.(${params.ids.join(',')})`;
      break;

    case 'GET_MANY_REFERENCE': {
      const { page, perPage } = params.pagination;
      options.headers.set('Range-Unit', 'items');
      options.headers.set('Range', `${(page - 1) * perPage}-${page * perPage - 1}`);
      options.headers.set('Prefer', 'count=exact');

      _params$sort = params.sort;
      field = _params$sort.field;
      order = _params$sort.order;

      const targetQuery = `${params.target}=eq.${params.id}`;
      const query = {
        order: `${field}.${order.toLowerCase()}`,
        ...convertFilters(params.filter)
      };

      url = `${apiUrl}/${resource}?${targetQuery}&${querystring.stringify(query, { strict: false, encode: false })}`;
      break;
    }
    case 'CREATE':
      url = `${apiUrl}/${resource}`;
      options.method = 'POST';
      options.headers.set('Prefer', 'return=representation');
      options.body = JSON.stringify(params.data);
      break;
    case 'UPDATE':
      url = `${apiUrl}/${resource}?id=eq.${params.id}`;
      options.method = 'PATCH';
      options.headers.set('Prefer', 'return=representation');
      options.body = JSON.stringify(params.data);
      break;
    case 'UPDATE_MANY':
      if (!params.ids || params.ids.length === 0) {
        const query = {
          ...convertFilters(params.filter)
        };
        url = `${apiUrl}/${resource}?${querystring.stringify(query, { strict: false, encode: false })}`;
      } else {
        url = `${apiUrl}/${resource}?id=in.(${params.ids.join(',')})`;
      }
      
      options.method = 'PATCH';
      options.headers.set('Prefer', 'return=representation');
      options.body = JSON.stringify(params.data);    
      break;
    case 'DELETE':
      url = `${apiUrl}/${resource}?id=eq.${params.id}`;
      options.method = 'DELETE';
      break;
    case 'DELETE_MANY':
      url = `${apiUrl}/${resource}?id=in.(${params.ids.join(',')})`;
      options.method = 'DELETE';
      break;
    default:
      throw new Error(`Unsupported fetch action type ${type}`);
  }
  return { url, options };
};

const convertHTTPResponseToREST = function (response, type, resource, params) {
  const headers = response.headers;
  let json = response.json;
  let total
  switch (type) {
    case 'GET_LIST':
    case 'GET_MANY_REFERENCE':
      if (!headers.has('content-range')) {
        throw new Error('The Content-Range header is missing in the HTTP Response.');
      }
      total = parseInt(headers.get('content-range').split('/').pop(), 10);

      // remap ids if necessary, dataProvider requires response like { data: [{ id: 123, ...}, ...]}
      if (json[0] && !json[0].id)
        json = json.map(obj => ({ ...obj, id: obj[params.target] }));

      return { data: json, total: total || 0 };
    case 'CREATE':
      return { data: { ...params.data, id: json[0].id } };
    case 'UPDATE':
      return { data: { ...params.data, ...json[0] } };
    case 'UPDATE_MANY':
      total = parseInt(headers.get('content-range').split('/').pop(), 10);
      return { data: json, total: total || 0 };
    case 'GET_ONE':
      return { data: json[0] };
    case 'DELETE':
      return { data: { id: params.id } };
    case 'DELETE_MANY':
      return { data: params.ids };
    default:
      return { data: json };
  }
};

// Updated data provider object for React-Admin 4
const dataProvider = (apiUrl, httpClient = _fetch.fetchJson) => ({
  getList: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'GET_LIST', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'GET_LIST', resource, params));
  },

  getOne: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'GET_ONE', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'GET_ONE', resource, params));
  },

  getMany: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'GET_MANY', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'GET_MANY', resource, params));
  },

  getManyReference: (resource, params) => {
    // response must be like { data: { id: 123, ...}, ...}
    // master_customer_history returns like { data: { event_id: 123, ...}, ...}
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'GET_MANY_REFERENCE', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'GET_MANY_REFERENCE', resource, params));
  },

  create: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'CREATE', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'CREATE', resource, params));
  },

  update: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'UPDATE', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'UPDATE', resource, params));
  },

  updateMany: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'UPDATE_MANY', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'UPDATE_MANY', resource, params));
  },  

  delete: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'DELETE', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'DELETE', resource, params));
  },

  deleteMany: (resource, params) => {
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'DELETE_MANY', resource, params);
    return httpClient(url, options).then(response => convertHTTPResponseToREST(response, 'DELETE_MANY', resource, params));
  },

  getCSV: (resource, params) => {
    
    const { url, options } = convertRESTRequestToHTTP(apiUrl, 'GET_LIST', resource, params);
    options.headers.set('Accept', 'text/csv');
    
    return httpClient(url, options).then(response => {
      // Handle CSV download
      // const blob = new Blob([response.body], { type: 'text/csv' });
      // const dateTime = new Date().toISOString().replace(/[:.-]/g, '_');
      // const filename = `${resource}-${dateTime}.csv`;
      
      // get the content-range header info from the response
      const contentRange = response.headers.get('content-range');
      const totalRecords = contentRange.split('/')[1]
      // if (window.navigator.msSaveOrOpenBlob) {
      //   // IE specific download
      //   window.navigator.msSaveBlob(blob, filename);
      // } else {
      //   // Create a temporary link element for download
      //   const link = document.createElement('a');
      //   link.href = URL.createObjectURL(blob);
      //   link.download = filename;
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // }

      return { data: response.body, total: parseInt(totalRecords) }; // Return the raw CSV content if needed
    });
  }
});

export default dataProvider;

